import React from "react";

const PrivacyPolicy = () => {
    return (
        <div style={styles.container}>
            <h1>Privacy Policy</h1>

            <p><strong>Effective Date:</strong> [Insert Date]</p>

            <p>
                Inaread ("we", "our", or "us") respects your privacy and is committed
                to protecting your personal data. This Privacy Policy explains how we
                collect, use, and safeguard your information when you use our mobile
                application, in compliance with applicable laws including the General
                Data Protection Regulation (GDPR) and the California Consumer Privacy
                Act (CCPA).
            </p>

            <h2>Information We Collect</h2>
            <p>We collect only the information necessary to provide our services:</p>
            <ul>
                <li>Email address</li>
                <li>Meter ID</li>
                <li>Meter type</li>
                <li>Country</li>
            </ul>

            <h2>How We Use Your Information</h2>
            <p>Your information is used strictly for the following purposes:</p>
            <ul>
                <li>To identify you as a user within the app</li>
                <li>To provide and maintain app functionality</li>
            </ul>

            <h2>Data Sharing and Disclosure</h2>
            <p>
                We do not sell, rent, or share your personal data with third parties.
                Your information is used solely for identification and operation of the app.
            </p>

            <h2>Legal Basis for Processing (GDPR)</h2>
            <ul>
                <li>Your consent when you provide your information</li>
                <li>Our legitimate interest in operating and improving the app</li>
            </ul>

            <h2>Your Rights (GDPR)</h2>
            <ul>
                <li>Access the personal data we hold about you</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your personal data</li>
                <li>Object to or restrict processing of your data</li>
                <li>Request data portability</li>
            </ul>

            <h2>Your Rights (CCPA)</h2>
            <ul>
                <li>Request disclosure of the personal data we collect about you</li>
                <li>Request deletion of your personal data</li>
                <li>Know that we do not sell your personal data</li>
                <li>Not be discriminated against for exercising your privacy rights</li>
            </ul>

            <h2>Data Retention</h2>
            <p>
                We retain your information only for as long as necessary to provide the
                app’s functionality and for identification purposes, unless a longer
                retention period is required or permitted by law.
            </p>

            <h2>Data Security</h2>
            <p>
                We implement reasonable technical and organizational measures to protect
                your personal data from unauthorized access, loss, misuse, or alteration.
            </p>

            <h2>Data Deletion Requests</h2>
            <p>You have the right to request deletion of your personal data at any time.</p>
            <p>To request data deletion, please contact us at:</p>
            <p><strong>Email:</strong> hello@inaread.com</p>
            <p>
                We may update this process in the future to provide an in-app deletion option.
            </p>

            <h2>Children’s Privacy</h2>
            <p>
                Our app is not directed to children under the age of 13, and we do not
                knowingly collect personal data from children.
            </p>

            <h2>Changes to This Privacy Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. Any changes will be
                reflected on this page with an updated effective date.
            </p>

            <h2>Contact Us</h2>
            <p>
                If you have any questions or concerns about this Privacy Policy or your
                data, please contact us at:
            </p>
            <p><strong>Email:</strong> hello@inaread.com</p>
        </div>
    );
};

const styles = {
    container: {
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
        margin: "20px",
        color: "#333",
        maxWidth: "800px",
    },
};

export default PrivacyPolicy;
